import { render, staticRenderFns } from "./PartnersSteps.vue?vue&type=template&id=02f8a122"
import script from "./PartnersSteps.vue?vue&type=script&lang=js"
export * from "./PartnersSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports